import { usePageStore } from '@/store/usePageStore';
import { isHomePage } from '@/utils/page';
import { useEffect, useState } from 'react';

export const useVisibilityFromBreadcrumb = (
  isProjectPage: boolean = true
): boolean => {
  const projectBreadcrumbPath = usePageStore((s) => s.projectBreadcrumbPath);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (
      isProjectPage &&
      projectBreadcrumbPath &&
      isHomePage(projectBreadcrumbPath)
    ) {
      setIsVisible(false);
    }
  }, [isProjectPage, projectBreadcrumbPath]);

  return isVisible;
};
